import Vue from 'vue';
import Vuetify from 'vuetify/lib';
import '@fortawesome/fontawesome-free/css/all.css'
import 'material-design-icons-iconfont/dist/material-design-icons.css'

import colors from 'vuetify/lib/util/colors'

Vue.use(Vuetify);

export default new Vuetify({
  theme: {
      options: {
        customProperties: true,
      },
    themes: {
      light: {
        primary: "#76A69B",
        secondary: "#e88f8f",
        accent: "#f99083",
        error: colors.red,
        info: colors.cyan.darken3,
        success: colors.lightGreen,
        warning: colors.amber
      },
    },
  },
  icons: {
    iconfont: 'fa'
    },
});
